import { Component } from '@inter-ikea-core/core';

/**
 * This is used to identify the host of an adjustable product like the clothrail.
 * That means this is most likely used to identify the frame that the
 * adjustable product is attached to.
 */
export default class AdjustableHostComponent implements Component {
  static id = 3007;
  typeId = AdjustableHostComponent.id;
  doStoreInSnapshot: boolean = true;
  serializable: boolean = false;

  eq() {
    return false;
  }
}
